<template lang="html">

  <section class="list-view row-center">

    <div class="contenedor-listado" :style="styles.backgroundWhite" v-if="!isFicha" :showEncuesta="!!encuestaView.id" :hasFicha="!!$route.params.id">
      <div class="scroll-container">
        <contenedor-tabla-responsive class="tabla-responsive" v-if="isResponsive"></contenedor-tabla-responsive>
        <contenedor-tabla class="tabla-pc" v-else></contenedor-tabla>
      </div>
    </div>
    <div class="contenedor-ficha" :style="ownstyle.ficha" v-if="showFicha" :full="fichaView.full" :showEncuesta="!!encuestaView.id">

      <div class="settings row-end" :style="styles.colorSoftBasic" v-if="!isFicha">
        <a @click="fichaView.full = !fichaView.full" class="icon-ampliar">
          <icon-ampliar v-if="!fichaView.full"></icon-ampliar>
          <icon-minificar v-if="fichaView.full"></icon-minificar>
        </a>
        <router-link :to="linkBack" title="Cerrar ficha">✕</router-link>
      </div>


      <div class="scroll-container">
        <contenedor-ficha v-if="$route.name != 'aprobaciones'" :full="fichaView.full" @cerrarFicha="back" @setEncuesta="setEncuesta"></contenedor-ficha>
        <contenedor-ficha-aprobaciones v-else :full="fichaView.full" @cerrarFicha="back" @setEncuesta="setEncuesta"></contenedor-ficha-aprobaciones>
      </div>

    </div>

    <div class="contenedor-vista-encuesta" :style="ownstyle.vistaEncuesta" :full="encuestaView.full" v-if="!!encuestaView.id">
      <div class="settings row-end" :style="styles.colorSoftBasic">
        <a @click="encuestaView.full = !encuestaView.full" class="icon-ampliar">
          <icon-ampliar v-if="!encuestaView.full"></icon-ampliar>
          <icon-minificar v-if="encuestaView.full"></icon-minificar>
        </a>
        <a @click="encuestaView.id = ''" title="Cerrar ficha">✕</a>
      </div>
      <vista-encuesta :id="encuestaView.id"></vista-encuesta>
    </div>


  </section>

</template>

<script lang="js">

 import {mapActions, mapGetters} from 'vuex';

 import ampliar from '@/components/parts/icons/ampliar';
 import minificar from '@/components/parts/icons/minificar';

 import contenedorTabla from '@/components/views/contenedor-tabla'
 import contenedorTablaResponsive from '@/components/views/contenedor-tabla-responsive'

 import contenedorFicha from '@/components/views/contenedor-ficha'
 import contenedorFichaAprobaciones from '@/components/views/aprobaciones/contenedor-ficha'

 import vistaEncuesta from '@/components/views/vista-encuesta'

 import router from '@/router';

 export default  {
  name: 'list-view',
  data(){
    return {
      fichaView : {
        full : false,
        view : false,
        id : ''
      },
      encuestaView : {
        full : false,
        id : ''
      },
      isResponsive: false
    }
  },
  mounted(){
    this.fichaView.full = (this.$route.name == 'ficha');
    this.isResponsive = window.innerWidth <= 1023;
  },
  methods : {
    ...mapActions(['setMenu']),
    back : function(){
      router.push(this.linkBack);
    },
    setEncuesta : function(value){
      this.encuestaView.id = value;
    }
  },
  components : {
    'icon-ampliar': ampliar,
    'icon-minificar': minificar,
    'contenedor-tabla' : contenedorTabla,
    'contenedor-tabla-responsive' : contenedorTablaResponsive,
    'contenedor-ficha' : contenedorFicha,
    'contenedor-ficha-aprobaciones' : contenedorFichaAprobaciones,
    'vista-encuesta' : vistaEncuesta
  },
  computed : {
    ...mapGetters({
      styles : 'getStyles',
      colors : 'basicColors',
      lang : 'getLanguage'
    }),
    ownstyle :function() {
      return {
        ficha :{
          'border-left': `10px solid ${this.colors.backgroundBody}`,
          background : this.colors.white
        },
        vistaEncuesta :{
          'border-left': `10px solid ${this.colors.backgroundBody}`,
          background : this.colors.white
        }
      }
    },
    linkBack : function(){
      return `${this.$route.meta.indexPath[this.lang]}/${this.$route.params.status}`;
    },
    isFicha : function(){
      return (this.$route.name == 'ficha');
    },
    showFicha : function(){

      let status = ["pendents","validades","rebutjades","pendientes","validadas","rechazadas","aprobadas","denegadas","en-curso","en-evaluacion","evaluados"];
      let show;

      show = (this.$route.params.status || this.$route.params.id);

      if(show){
        show = (!status.some(e => this.$route.params.status == e))
        if(!show){
          show = this.$route.params.id;
        }
      }
      
      return show;
    }
  },
  watch : {
    '$route' : function(){
      var width = $(window).width();
      if(!!this.$route.params.id && width <= 1400){
        this.setMenu(false);
      }
      this.fichaView.full = (this.$route.name == 'ficha');
      // console.log(this.$route.params);
    },
    'encuestaView.id' : function(){
      var width = $(window).width();
      if(!!this.encuestaView.id && width <= 1800){
        this.setMenu(false);
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .list-view{
    width: 100%;
    height: 100%;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;
    max-height:100%;
    position: relative;
    
  }

  .contenedor-listado {
    width: 100%;
    height: 100%;
    display: inline-block;
    overflow: hidden;
    padding: 20px;

    &[showEncuesta=true]{
      width:auto;
    }
  }

  .contenedor-ficha{
    width: 100%;
    height: 100%;
    display: inline-block;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    padding: 10px;
    position: relative;
    
    &[full="true"]{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 7;
      max-width: 100%;
      border-left: none!important;
    }


  } 

  .scroll-container{
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: inline-block;
    overflow: hidden;
  }


  .contenedor-ficha .scroll-container{
    overflow: hidden;
  }

  .settings{
    position: absolute;
    right: 5px;
    top: 0;
    height: 30px;
    width:100px;
    z-index: 5;
  }

  .settings a{
    width: 25px;
    height: 30px;
    display: inline-block;
    line-height: 30px;
  }

  .contenedor-vista-encuesta{
    width: 100%;
    height: 100%;
    max-width: 600px;
    min-width: 500px;
    overflow: hidden;
    position: relative;
    flex-grow: 2;
    &[full="true"]{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 5;
      max-width: 100%;
      border-left: none!important;
    }
  }

  .tabla-responsive{
    display: none;
  }

  @media screen and (max-height: 900){
    .contenedor-listado{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }
  }

  @media screen and (max-width: 1400px){
    .contenedor-listado {
      &[showEncuesta=true]{
        display: none;
      }
    }

    .contenedor-ficha{
      max-width: 100%;
      &[showEncuesta=true]{
        border-left: none!important;
      }
    }

    .contenedor-vista-encuesta{
      max-width: 100%;
    }

  }

  @media screen and (max-width: 1200px){
    .contenedor-listado[hasFicha="true"]{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }
  }

  @media screen and (max-width: 1023px){
   .contenedor-listado {
    &[hasFicha=true]{
      display: none;
    }
  }

  .contenedor-listado{
      .tabla-responsive{
        display: inline-block;
        width: 100%;
      }
      .tabla-pc{
        display: none;
      } 
    }


  .contenedor-ficha[showEncuesta="true"]{
    display: none;
  }

  .settings .icon-ampliar{
    display: none;
  }
  .contenedor-ficha{
    border-left: none!important;
    min-width: 0;
  }
  .contenedor-vista-encuesta{
    min-width: 0;
    border-left: none!important;
  }

}

  @media screen and (max-width: 600px){
    .contenedor-listado{
      padding: 10px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/views/list-view.vue